import { render, staticRenderFns } from "./ComfirmationTable.vue?vue&type=template&id=16041e52&scoped=true&"
import script from "./ComfirmationTable.vue?vue&type=script&lang=js&"
export * from "./ComfirmationTable.vue?vue&type=script&lang=js&"
import style0 from "./ComfirmationTable.vue?vue&type=style&index=0&id=16041e52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16041e52",
  null
  
)

export default component.exports